import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import Table from "../../../../../../common/components/table";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { taxCategories } from "../../../../../../redux/tax-categories/action";
import { selectTaxCategoriesReadItem } from "../../../../../../redux/tax-categories/selector";

const ManagementTaxCategories = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const TaxCategoryItems = useSelector(selectTaxCategoriesReadItem)

    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'TaxName', headerName: 'Name' },
          { field: 'TaxPercentage', headerName: 'Tax Percentage' },
          { field: 'TaxClasificationName', headerName: 'Tax Clasification Name' },
          { field: 'TallyLedgerName', headerName: 'Tally Ledger Name' },
          { field: 'Remarks', headerName: 'Remarks' },
          { field: 'TaxType', headerName: 'Tax Type' }
      
        ]);
      }
    
	useEffect(() => {
        createColumnDefs()
		dispatch(taxCategories.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/Taxes`,entity:'taxCategories',
      }))
	}, [])

  const handleEdit=(data: any)=>{
    // navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{

  } 
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add TaxCategories',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
    {TaxCategoryItems?.isLoading ? 
    <PageLoader />
: 
		<Table columnData={columnDefs} rowData={TaxCategoryItems?.result?.items} 
    onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Tax Categories" />
  }
  </>  
	);
};

export default ManagementTaxCategories;


